<div class="comments-list overflow-hidden" *ngIf="commentsList?.length > 0">
  <div class="px-3 pt-2 comment-section">
    <div class="pb-2" *ngFor="let comments of commentsList">
      <kl-social-comments-tile [comment]="comments"></kl-social-comments-tile>
    </div>
  </div>
</div>
